import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ACCIONES = {
  borrador_ia: [{ accion: "enviar", label: "Enviar a revisión", need: "editar" }],
  en_revision: [
    { accion: "aprobar", label: "Aprobar", need: "aprobar" },
    { accion: "devolver", label: "Devolver", need: "aprobar", notas: true },
  ],
  aprobado_legal: [
    { accion: "publicar", label: "Publicar", need: "publicar" },
    { accion: "devolver", label: "Devolver", need: "aprobar", notas: true },
  ],
  publicado: [],
};

export const AccionesEstado = ({ kind, entry, permisos, onDone }) => {
  const [pending, setPending] = useState(null);
  const [notas, setNotas] = useState("");
  const [busy, setBusy] = useState(false);
  const allowed = (need) => need === "editar" || (need === "aprobar" && permisos.puede_aprobar) || (need === "publicar" && permisos.puede_publicar);

  const run = async (a, n) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/copiloto/${kind}/${encodeURIComponent(entry.id)}/accion`, { accion: a.accion, notas: n });
      onDone(data);
      toast.success(`${a.label}: listo`);
      setPending(null); setNotas("");
    } catch (e) { toast.error(e.response?.data?.detail || "No se pudo completar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {(ACCIONES[entry.estado] || []).filter((a) => allowed(a.need)).map((a) => (
        <Button key={a.accion} size="sm" variant={a.accion === "devolver" ? "outline" : "default"} disabled={busy}
          className={a.accion === "devolver" ? "h-8" : "h-8 bg-[#1E3A5F] hover:bg-[#16304F]"}
          data-testid={`accion-${a.accion}-${entry.id}`}
          onClick={() => (a.notas || a.accion === "aprobar" ? setPending(a) : run(a, ""))}>
          {a.label}
        </Button>
      ))}
      <Dialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
        <DialogContent data-testid="accion-dialog">
          <DialogHeader><DialogTitle>{pending?.label}</DialogTitle></DialogHeader>
          <textarea value={notas} onChange={(e) => setNotas(e.target.value)} rows={4}
            placeholder={pending?.notas ? "Qué hay que corregir (obligatorio)" : "Notas del revisor (opcional)"}
            data-testid="accion-notas" className="w-full rounded-lg border border-[#CBD5E1] p-2 text-sm" />
          <DialogFooter>
            <Button disabled={busy || (pending?.notas && !notas.trim())} onClick={() => run(pending, notas)} data-testid="accion-confirmar">
              Confirmar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
